export const CARD_TYPES = {
  topAvatarShadow: 1,
  leftAvatar: 2,
  question: 3,
  progress: 4,
  contacts: 5,
  link: 6,
  image: 7,
  video: 8,
  document: 9,
};

export const SECTION_TYPES = {
  generic: 1, // Секция с карточками или просто загловок и описание
  title: 2, // Заглавная секция с бекграундом и ценой
  units: 3, // Секция с темами
  links: 4, // Секция с ссылками
  gallery: 5, // Секция с галереей
  video: 6, // Секция с галереей
  documents: 9,
};
